import React, { useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { Save, Building } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";

const AdminSettings = () => {
  const { toast } = useToast();
  const [settings, setSettings] = useState({
    businessName: "Evershine Services",
    phone: "+61 434 344 277",
    email: "info@evershinetiling.com.au",
    address: "Brisbane, Gold Coast, Sunshine Coast",
    aboutText:
      "Evershine Services provides reliable and professional tiling services across Brisbane, Gold Coast, and Sunshine Coast.",
    businessHours: {
      weekdays: "7:00 AM - 6:00 PM",
      saturday: "8:00 AM - 4:00 PM",
      sunday: "Closed",
    },
  });

  const handleChange = (field, value) => {
    setSettings({ ...settings, [field]: value });
  };

  const handleHoursChange = (day, value) => {
    setSettings({
      ...settings,
      businessHours: { ...settings.businessHours, [day]: value },
    });
  };

  const handleSave = () => {
    // In a real app, this would save to database
    toast({
      title: "Settings Saved",
      description: "Your changes have been saved successfully.",
    });
  };

  return (
    <AdminLayout>
      <div>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Settings
          </h2>
        </div>

        <div className="space-y-6">
          {/* Business Information */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-2 mb-6">
              <Building className="w-5 h-5 text-blue-600" />
              <h3 className="text-xl font-bold text-gray-900">
                Business Information
              </h3>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Business Name
                </label>
                <Input
                  value={settings.businessName}
                  onChange={(e) => handleChange("businessName", e.target.value)}
                  className="w-full"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <Input
                    value={settings.phone}
                    onChange={(e) => handleChange("phone", e.target.value)}
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <Input
                    type="email"
                    value={settings.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                    className="w-full"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Service Areas
                </label>
                <Input
                  value={settings.address}
                  onChange={(e) => handleChange("address", e.target.value)}
                  className="w-full"
                  placeholder="e.g., Brisbane, Gold Coast, Sunshine Coast"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  About Text
                </label>
                <Textarea
                  value={settings.aboutText}
                  onChange={(e) => handleChange("aboutText", e.target.value)}
                  rows={4}
                  className="w-full"
                />
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-6">
              Business Hours
            </h3>
            <div className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                <label className="text-sm font-medium text-gray-700">
                  Monday - Friday
                </label>
                <Input
                  value={settings.businessHours.weekdays}
                  onChange={(e) =>
                    handleHoursChange("weekdays", e.target.value)
                  }
                  className="w-full"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                <label className="text-sm font-medium text-gray-700">
                  Saturday
                </label>
                <Input
                  value={settings.businessHours.saturday}
                  onChange={(e) =>
                    handleHoursChange("saturday", e.target.value)
                  }
                  className="w-full"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                <label className="text-sm font-medium text-gray-700">
                  Sunday
                </label>
                <Input
                  value={settings.businessHours.sunday}
                  onChange={(e) => handleHoursChange("sunday", e.target.value)}
                  className="w-full"
                />
              </div>
            </div>
          </div>

          {/* Save Button */}
          <div className="flex justify-end">
            <Button
              onClick={handleSave}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3"
            >
              <Save className="w-4 h-4 mr-2" />
              Save All Changes
            </Button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminSettings;
